
/**
 * Created by nijin on 13/1/17.
 */
export class ThingModel{
  constructor(){
    this.connection = new ConnectionMinModel();
    this.schema = new SchemaMinModel();
  }
  id: number;
  accountId: number;
  name: string;
  description: string;
  createdDate?: any;
  schema: SchemaMinModel;
  connection: ConnectionMinModel;
  secureGroup: SecureGroup;
  tags: Array<string>;
  active: boolean;
  lastReportedTime: any;
  token: string;
  online:boolean

}

export class ConnectionMinModel{
  id: number;
  name: string;
}
export class SchemaMinModel{
  id: number;
  name: string;
}

export class SecureGroup{
  id: number;
  name: string;
}

export interface IThingBasicInfo{
  name: string,
  description: string,
  tags: Array<string>
}



// WEBPACK FOOTER //
// ./src/app/things/model/Ithing.model.ts